<template>
  <edit-abs :service="service" />
</template>

<script>
import ServiceClient from "@/services/ServiceClient";
import EditAbs from "./EditAbs";
export default {
  name: "Password-Edit",
  components: {
    EditAbs
  },
  data: () => ({
    service: ServiceClient
  }),
  methods: {}
};
</script>
<style>
</style>
